import { AxiosError } from 'axios';
import { useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useFeedbackAnalysisReport = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [feedbackAnalysisReportData, setFeedbackAnalysisReportData] = useState<FeedbackAnalysisReportDataInterface | null>(null);

    const onFeedbackAnalysisReportDataError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong');
    };

    const onFeedbackAnalysisReportDataSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<FeedbackAnalysisReportDataInterface>) => {
        setFeedbackAnalysisReportData(data);
    };

    const getFeedbackAnalysisReportData = (driverId: string) => {
        const url: HttpConfig = {
            url: `api/v1/dispatchers/${driverId}/feedbacks/metrics`,
            method: 'get',

        };
        request(url, onFeedbackAnalysisReportDataSuccess, setLoading, onFeedbackAnalysisReportDataError);
    };

    return { getFeedbackAnalysisReportData, loading, feedbackAnalysisReportData };
};

export default useFeedbackAnalysisReport;


export interface FeedbackAnalysisReportDataInterface {
    positiveCount: number;
    negativeCount: number;
    totalCount: number;
    positivePercentage: number;
    averageRating: number;
    averageRatingChange: number;
    totalCountChangePercent: number;
};
